import React, { memo } from 'react'

import customConfig from 'customConfig'
import ScanQrCode from '../../shared/scanQrCode/ScanQrCode'

const ReceiveRewardByQrCode = ({ t, ...restProps }) => {
  return (
    <ScanQrCode
      title={t(customConfig.receiveYourRewardLabel)}
      description={t(customConfig.scanCodeAndReceivePointsLabel)}
      cancelLabel={t('common.cancel')}
      {...restProps}
    />
  )
}

export default memo(ReceiveRewardByQrCode)
